import { MessageCircle } from "lucide-react";
import { Logo } from "@/components/Navigation";
import SocialIcons from "@/components/SocialIcons";
import { buildWhatsAppUrl } from "@/components/WhatsAppButton";

const Footer = () => {
  return (
    <footer
      data-testid="footer"
      className="relative border-t border-[#F0EBE1]/10 px-6 md:px-12 lg:px-24 pt-16 pb-10 bg-[#080B12]"
    >
      <div className="grid md:grid-cols-12 gap-10 mb-12 items-start">
        <div className="md:col-span-7">
          <div className="mb-6">
            <Logo size="large" />
          </div>
          <p className="text-[#F0EBE1]/55 font-light max-w-md leading-relaxed">
            Luxury wedding planners and designers based in Mumbai, crafting
            bespoke destination weddings across India and worldwide.
          </p>
          <div className="mt-6 text-[#F0EBE1]/50 text-sm font-light leading-relaxed max-w-md">
            Aston Building, 10th Floor, Andheri West, Mumbai 400053
          </div>
        </div>

        <div className="md:col-span-5 md:text-right">
          <div className="overline mb-4">Follow</div>
          <div className="md:flex md:justify-end mb-8">
            <SocialIcons />
          </div>

          <div className="overline mb-4">Quick Chat</div>
          <a
            href={buildWhatsAppUrl()}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="footer-whatsapp-btn"
            className="inline-flex items-center gap-3 px-6 py-3 bg-[#B8935C] text-[#080B12] text-[10px] uppercase tracking-[0.28em] font-semibold hover:bg-[#D4AF37] transition-all duration-500"
          >
            <MessageCircle size={14} strokeWidth={1.8} />
            Chat on WhatsApp
          </a>
        </div>
      </div>

      <div className="border-t border-[#F0EBE1]/10 pt-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
        <div className="text-[#F0EBE1]/40 text-xs font-light">
          © {new Date().getFullYear()} Bon Evento. All rights reserved.
        </div>
        <div className="text-[#F0EBE1]/40 text-xs font-light">
          Crafted with love in Mumbai
        </div>
      </div>
    </footer>
  );
};

export default Footer;
